<template>
  <div class="router-wrapper">
    <div class="content-box">
      <div class="element-wrapper">
        <div class="os-tabs-w">
          <div class="os-tabs-controls os-tabs-complex">
            <div class="nav-item">
              <h1>{{ $t("products_import.heading") }}</h1>
            </div>
          </div>
        </div>

        <div class="row" style="padding-left: 10px">
          <div class="col-sm-12 col-lg-6 col-xxl-6">
            <div class="element-wrapper">
              <h6 class="element-header">{{ $t("products_import.step_1") }}</h6>
              <div class="element-box-tp">
                <div class="profile-tile " style="align-items: flex-start;border: none">
                  <div class="profile-tile-box upload-box" style="padding: 0; width: 275px;">
                    <button type="button" class="button clear-button" @click="clearProductData">
                      {{ $t("products_import.clear") }}
                    </button>
                    <vue-dropzone
                      ref="myVueDropzone"
                      id="dropzone"
                      class="upload-dropzone"
                      :options="productOptions"
                      :use-custom-dropzone-options="true"
                    >
                    </vue-dropzone>

                    <div
                      v-if="
                        productData.length > 0 &&
                          !isImportingProducts &&
                          !importingProductsComplete &&
                          !isValidatingData &&
                          !validatingProductDataCompleted
                      "
                      class="button-container"
                    >
                      <button
                        class="button"
                        color="primary"
                        style="margin-bottom: 20px; margin-top: 20px;"
                        v-on:click="validateProductData"
                      >
                        {{ $t("products_import.validate") }}
                      </button>
                    </div>

                    <div v-else-if="isValidatingData" class="button-container">
                      {{ $t("products_import.is_validating") }}
                    </div>

                    <div
                      v-else-if="!isValidatingData && validatingProductDataCompleted && errors.length > 0"
                      class="row"
                    >
                      <div class="row" style="padding: 20px 40px 0 40px;">
                        <div class="alert alert-danger" style="width: 235px;">
                          {{ $t("products_import.errors_occurred") }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="
                        productData.length > 0 &&
                          errors.length === 0 &&
                          !isImportingProducts &&
                          !importingProductsComplete &&
                          !importingProductError
                      "
                      class="button-container"
                    >
                      <button
                        class="button"
                        color="primary"
                        style="margin-bottom: 20px; margin-top: 20px;"
                        v-on:click="importProductData"
                      >
                        {{ productData.length }}
                        {{ $t("products_import.import_data") }}
                      </button>
                    </div>
                    <div v-else-if="isImportingProducts" class="button-container">
                      {{ $t("products_import.importing_data") }}
                    </div>
                    <div v-else-if="importingProductsComplete" class="row">
                      <div class="row" style="padding: 20px 40px 0 40px;">
                        <div class="alert alert-success" style="width: 235px;">
                          {{ $t("products_import.import_successful") }}
                        </div>
                      </div>
                    </div>
                    <div v-else-if="importingProductError" class="row">
                      <div class="row" style="padding: 20px 40px 0 40px;">
                        <div class="alert alert-danger" style="width: 235px;">
                          {{ importingProductError }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-lg-6 col-xxl-6">
            <div class="element-wrapper">
              <h6 class="element-header">{{ $t("products_import.step_2") }}</h6>
              <div class="element-box-tp">
                <div class="profile-tile" style="align-items: flex-start;border: none">
                  <div class="profile-tile-box upload-box" style="padding: 0; width: 275px;">
                    <button type="button" class="button clear-button" @click="clearProductTemplateData">
                      {{ $t("products_import.clear") }}
                    </button>
                    <vue-dropzone
                      ref="templateZone"
                      id="templateZone"
                      :options="templateOptions"
                      class="upload-dropzone"
                    >
                    </vue-dropzone>

                    <div
                      v-if="
                        templateData.length > 0 &&
                          !isImportingTemplate &&
                          !importingTemplateComplete &&
                          !isValidatingProductTemplateData &&
                          !validationOfProductTemplateDataCompleted
                      "
                      class="button-container"
                    >
                      <button
                        class="button"
                        color="primary"
                        style="margin-bottom: 20px; margin-top: 20px;"
                        v-on:click="onValidateProductTemplateImport"
                      >
                        {{ $t("products_import.validate") }}
                      </button>
                    </div>

                    <div v-else-if="isValidatingProductTemplateData" class="button-container">
                      {{ $t("products_import.is_validating") }}
                    </div>
                    <div
                      v-else-if="
                        !isValidatingProductTemplateData &&
                          validationOfProductTemplateDataCompleted &&
                          errors.length > 0
                      "
                      class="row"
                    >
                      <div class="row" style="padding: 20px 40px 0 40px;">
                        <div class="alert alert-danger" style="width: 235px;">
                          {{ $t("products_import.errors_occurred") }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="
                        templateData.length > 0 &&
                          errors.length === 0 &&
                          !isValidatingProductTemplateData &&
                          !importingTemplateComplete &&
                          !importingTemplateError &&
                          !isImportingTemplate
                      "
                      class="button-container"
                    >
                      <button
                        class="button"
                        color="primary"
                        style="margin-bottom: 20px; margin-top: 20px;"
                        v-on:click="importProductTemplateData"
                      >
                        {{ templateData.length }}
                        {{ $t("products_import.import_data") }}
                      </button>
                    </div>
                    <div v-else-if="isImportingTemplate" class="button-container">
                      {{ $t("products_import.importing_data") }}
                    </div>
                    <div v-else-if="importingTemplateComplete" class="row">
                      <div class="row" style="padding: 20px 40px 0 40px;">
                        <div class="alert alert-success" style="width: 235px;">
                          {{ $t("products_import.import_successful") }}
                        </div>
                      </div>
                    </div>
                    <div v-else-if="importingTemplateError" class="row">
                      <div class="row" style="padding: 20px 40px 0 40px;">
                        <div class="alert alert-danger" style="width: 235px;">
                          {{ importingTemplateError }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="errors.length > 0">
          <div class="col-12">
            <ImportErrorTable :errors="errors" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapState, mapActions } from "vuex";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import ImportErrorTable from "@/components/products/partials/import-error-table";

export default {
  name: "ProductsImport",
  components: {
    vueDropzone: vue2Dropzone,
    ClipLoader,
    ImportErrorTable
  },
  data() {
    return {
      productOptions: {
        url: "blub",
        acceptedFiles: ".csv",
        maxFiles: 1,
        thumbnailWidth: 50,
        dictDefaultMessage: "Click to select CSV file",
        accept: this.acceptProductCSV
      },
      templateOptions: {
        url: "asdf",
        maxFiles: 1,
        acceptedFiles: ".csv",
        thumbnailWidth: 150,
        dictDefaultMessage: "Click to select CSV file",
        accept: this.acceptTemplateCSV
      },
      productData: [],
      templateData: [],
      showProductInfo: false,
      isImportingProducts: false,
      importingProductsComplete: false,
      importingProductError: null,
      showTemplateInfo: false,
      isImportingTemplate: false,
      importingTemplateComplete: false,
      importingTemplateError: null,
      isValidatingData: false,
      validatingProductDataCompleted: false,
      isValidatingProductTemplateData: false,
      validationOfProductTemplateDataCompleted: false,
      errors: []
    };
  },
  methods: {
    ...mapActions({
      importProducts: "productStore/import",
      importProductsTempData: "productStore/importProductTemplateData",
      validateProductImport: "productStore/validateProductImport",
      validateProductTemplateImport: "productStore/validateProductTemplateImport"
    }),
    acceptProductCSV(file, done) {
      this.clearProductTemplateData();
      const reader = new FileReader();
      reader.addEventListener("loadend", event => {
        const result = event.target.result.toString();
        const rows = result.split(/\r?\n/);

        if (rows.length > 0) {
          const cols = rows[0].split(";").filter(s => s !== "");
          const products = [];

          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];

            if (/^[;]*$/.test(row)) {
              // empty row
              continue;
            }

            const content = row.split(";");
            const product = {};

            for (let j = 0; j < cols.length; j++) {
              if (content[j] !== void 0) {
                // array element does exist
                let element = product[cols[j]];
                if (typeof element === "undefined") {
                  element = [content[j]];
                  product[cols[j]] = element;
                } else {
                  element.push(content[j]);
                }
              }
            }

            products.push(product);
          }

          this.productData = products;
        }
      });
      reader.readAsText(file);
    },
    acceptTemplateCSV(file, done) {
      this.clearProductData();
      const reader = new FileReader();
      reader.addEventListener("loadend", event => {
        const result = event.target.result.toString();
        const rows = result.split(/\r?\n/);

        if (rows.length > 0) {
          const cols = rows[0]
            .split(";")
            .filter(s => s !== "")
            .map(c => c.trim());
          const templateData = [];

          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];

            if (/^[;]*$/.test(row)) {
              // empty row
              continue;
            }

            const content = row.split(";");
            const data = {};

            for (let j = 0; j < cols.length; j++) {
              const element = null;
              if (content[j] !== void 0 || content[j] !== "" || !content[j]) {
                data[cols[j]] = content[j].replace(/,/g, ".").trim();
              }
            }

            templateData.push(data);
          }

          this.templateData = templateData;
        }
      });
      reader.readAsText(file);
    },
    importProductData() {
      this.isImportingProducts = true;
      this.importProducts(this.productData)
        .then(r => {
          this.isImportingProducts = false;
          this.importingProductsComplete = true;
        })
        .catch(e => {
          console.error(e);
          this.importingProductError = e.message;
          this.importingProductsComplete = false;
          this.isImportingProducts = false;
        });
    },
    validateProductData() {
      this.isValidatingData = true;

      this.validateProductImport(this.productData)
        .then(errors => {
          this.isValidatingData = false;
          this.validatingProductDataCompleted = true;
          this.errors = errors;
        })
        .catch(e => {
          console.error(e);
          this.validatingProductDataCompleted = true;
        });
    },
    onValidateProductTemplateImport() {
      this.isValidatingProductTemplateData = true;

      this.validateProductTemplateImport(this.templateData)
        .then(result => {
          this.isValidatingProductTemplateData = false;
          this.validationOfProductTemplateDataCompleted = true;
          this.errors = result.data.validateProductTemplateData;
        })
        .catch(e => {
          console.error(e);
          this.validationOfProductTemplateDataCompleted = true;
        });
    },
    clearProductData() {
      this.$refs.myVueDropzone.removeAllFiles(true);
      this.isValidatingData = false;
      this.validatingProductDataCompleted = false;
      this.isImportingProducts = false;
      this.importingProductsComplete = false;
      this.errors = [];
      this.productData = [];
      this.importingProductError = null;
    },
    clearProductTemplateData() {
      this.$refs.templateZone.removeAllFiles(true);
      this.isValidatingProductTemplateData = false;
      this.validationOfProductTemplateDataCompleted = false;
      this.isImportingTemplate = false;
      this.importingTemplateComplete = false;
      this.errors = [];
      this.templateData = [];
      this.importingTemplateError = null;
    },
    importProductTemplateData() {
      this.isImportingTemplate = true;

      this.importProductsTempData(this.templateData)
        .then(r => {
          if (r.data.error) {
            this.importingTemplateError = r.data.error;
            this.importingTemplateComplete = false;
            this.isImportingTemplate = false;
          } else {
            this.isImportingTemplate = false;
            this.importingTemplateComplete = true;
          }
        })
        .catch(e => {
          console.error(e);
          this.importingTemplateError = e;
          this.importingTemplateComplete = false;
          this.isImportingTemplate = false;
        });
    }
  },
  computed: {
    ...mapState("productStore", ["productInfo"])
  }
};
</script>

<style scoped>
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.clear-button {
  width: 70px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 4px;
}

.upload-dropzone {
  width: 100%;
}

.button-container {
  width: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
